import { render } from "./PayrollCost.vue?vue&type=template&id=79e7b8ad&scoped=true"
import script from "./PayrollCost.vue?vue&type=script&lang=js"
export * from "./PayrollCost.vue?vue&type=script&lang=js"

import "./PayrollCost.vue?vue&type=style&index=0&id=79e7b8ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e7b8ad"]])

export default __exports__